

























import store from '@/store';
import LabelInput from '@/views/molecules/LabelInput.vue'
import ActiveButton from '@/views/atoms/ActiveButton.vue'
import RightBox from '@/views/molecules/RightBox.vue'
import ApiClient from '@/common/api'

export default
  name: 'Login'
  components: {
    LabelInput
    RightBox
    ActiveButton
  }

  created: () ->
    store.dispatch('initPostParam')

  data: () ->
    error_message: ''

  methods: {
    click: (e) ->
      @error_message = ''
      api = new ApiClient()
      data = await api.post('/customs_broker/login/login', null, false)
      if data.state == 200
        @$router.push '/partner/top'
        return
      @error_message = data.errors.loginid.error
  }
